import React from "react";
import { UsernameCollectionFabric } from "@msidentity/SISU/components/username-collection/fabric/username-collection-fabric";
import { ViewContainerFabric } from "@msidentity/SISU/components/view-container/fabric/view-container-fabric";
import { FlowId, ViewId } from "@msidentity/SISU/constants/routing-constants";
import { useDocumentTitle } from "@msidentity/SISU/hooks";
import { useActivateView } from "@msidentity/SISU/hooks/use-activate-view";
import { usernameRecoveryGenericStringsFabric } from "../../../fabric/username-recovery-strings-fabric";
import { useCollectProofView } from "../model/hooks/use-collect-proof";

/**
 * Collect Proof View Component for Username Recovery Flow
 * @returns instance of the view
 */
export const CollectProofViewFabric: React.FC<{}> = function CollectProofViewFabric() {
  const { inputType, setInputType, viewProps, easiInputProps, phoneInputProps } =
    useCollectProofView();

  useActivateView(ViewId.UsernameRecoveryCollect, FlowId.UsernameRecovery, {
    showIdentityBanner: false,
  });
  useDocumentTitle(viewProps.title.title);

  return (
    <ViewContainerFabric {...viewProps}>
      <UsernameCollectionFabric
        currentInputType={inputType}
        easiInputProps={easiInputProps}
        phoneInputProps={phoneInputProps}
        easiSwitchLinkText={usernameRecoveryGenericStringsFabric.easiSwitchLink}
        setCurrentInputType={setInputType}
      />
    </ViewContainerFabric>
  );
};
